module.exports = "<h1 class=\"error-message\">Server Unavailable</h1>\n<p class=\"error-details\">Is platform-controller / enrich-api running? See logs below for the current environment and more information.</p>\n<pre class=\"log\"><ng-container *ngFor=\"let logMessage of logMessages\">{{logMessage}}</ng-container></pre>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/errors/server-unavailable/server-unavailable.page.html
// module id = ./src/app/pages/errors/server-unavailable/server-unavailable.page.html
// module chunks = main